// import config from 'config';
import { authHeader } from "../_helpers";

const API_URL = "http://api.lanahill.style/api/v1";

export const portfolioItemService = {
  getAll,
  getById,
  getByPortfolioId,
  update,
  delete: _delete,
};

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Access-Control-Allow-Origin":"*" }
  };

  return fetch(`${API_URL}/portfolioitem`, requestOptions)
    .then(_handleResponse)
    .then(_handleUserData);
}

function getById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${API_URL}/portfolioitem/${id}`, requestOptions)
    .then(_handleResponse)
    .then(_handleUserData);
}

function getByPortfolioId(portfolio_id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${API_URL}/portfolioitem/?portfolio_id=${portfolio_id}`, requestOptions)
    .then(_handleResponse)
    .then(_handleUserData);
}

function update(portfolioitem) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(portfolioitem),
  };

  return fetch(`${API_URL}/portfolioitem/${portfolioitem.id}`, requestOptions)
    .then(_handleResponse)
    .then(_handleUserData);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(`${API_URL}/portfolioitem/${id}`, requestOptions).then(_handleResponse);
}

function _handleResponse(response) {
  return response.text().then((text) => {
    const dataObject = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // window.location.reload(true);
      }

      const error = (dataObject && dataObject.message) || response.statusText;
      return Promise.reject(error);
    }

    // console.log('dataObject - ', dataObject);
    return dataObject;
  });
}

// this function getting data from response and returns them as an array
function _handleUserData(dataObject) {
  const data = dataObject ? dataObject.data : [];
  const dataArray = Array.isArray(data)
    ? data.map((item) => _transformData(item))
    : _transformData(data);

  return dataArray;
}

// this function transforms and returns a structure of user's data for further using
function _transformData(data) {
  return {
    id: data.id,
    portfolioId: data.portfolio_id,
    imageFileName: data.image_file_name,
    url: data.url,
    isPrimary: data.is_primary,
    isBefore: data.is_before,
    isActive: data.is_active,
    portfolioItemSort: data.portfolio_item_sort
  };
}
